import { render, staticRenderFns } from "./SalesDetailHeader.vue?vue&type=template&id=672a4f3e&scoped=true&"
import script from "./SalesDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./SalesDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SalesDetailHeader.vue?vue&type=style&index=0&id=672a4f3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672a4f3e",
  null
  
)

export default component.exports